var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSushi9ErFullblack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 15.000000)",
    fill: "currentColor",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 27,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 0,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 54,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 0,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 27,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 54,
    width: 16,
    height: 16,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi9ErFullblack);
export default __webpack_public_path__ + "static/media/Sushi 9er Full black.fc4743e8d1dfe8aca33f59e4e34ca441.svg";
export { ForwardRef as ReactComponent };